"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBikeStations = useBikeStations;
var _colors = require("@mui/material/colors");
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _bikeStationPopup = _interopRequireDefault(require("../../components/map/bike-station-popup"));
var _models = require("../../models");
var _utils = require("../../utils");
var _layers = require("./layers");
var _popup = require("./popup");
var _routing = require("./routing");
var _source = require("./source");
var _maplibreGl = require("!maplibre-gl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const sourceId = 'bike-stations';
const layerId = 'bike-stations';
const asMarkerMinZoom = 14.5;
function useBikeStations(map, theme, search, smallDevice) {
  let {
    onSearchUpdated
  } = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  const [selectedBikeStation, selectBikeStation] = (0, _react.useState)(null);
  const initialized = (0, _react.useRef)(false);
  const {
    getGeoJSONSource,
    addGeoJSONSource,
    updateGeoJSONSource,
    clearGeoJSONSource
  } = (0, _source.useSource)(map, sourceId);
  const {
    addCircleLayer
  } = (0, _layers.useLayers)(map);
  const bikeStationsRef = (0, _react.useRef)([]);
  const selectedIdRef = (0, _react.useRef)(null);
  const markers = (0, _react.useRef)({});
  const tooltip = (0, _react.useRef)();
  const snackbar = (0, _notistack.useSnackbar)();
  const {
    centerPopup
  } = (0, _popup.usePopup)(map);
  function init() {
    if (!map || initialized.current) return;
    if (getGeoJSONSource()) {
      initialized.current = true;
      return;
    }
    tooltip.current = new _maplibreGl.Popup({
      className: 'map-tooltip',
      closeButton: false
    });
    addGeoJSONSource();
    addCircleLayer(layerId, sourceId, {
      'circle-radius': 4,
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1,
      'circle-color': ['get', 'color'],
      'circle-stroke-color': '#fff'
    });
    map.on('mouseenter', layerId, event => {
      if (event.defaultPrevented) return;
      event.originalEvent.preventDefault();
      event.preventDefault();
      map.getCanvas().style.cursor = 'pointer';
      const {
        point,
        features
      } = event;
      if (map.queryRenderedFeatures(point).find(_ref => {
        let {
          layer: {
            id: layerId
          }
        } = _ref;
        return [_routing.wayPointsLayerId, _routing.arrivalLayerId].indexOf(layerId) !== -1;
      }) || !features || !features[0]) return;
      const {
        id,
        geometry,
        properties
      } = features[0];
      if (selectedIdRef.current === id) return;
      if (typeof id === 'number' && geometry.type === 'Point') {
        const {
          coordinates: [lng, lat]
        } = geometry;
        openTooltip(id, {
          lat,
          lng
        }, properties?.title || null, 6);
      }
    });
    map.on('click', layerId, event => {
      if (event.originalEvent.defaultPrevented) return;
      event.originalEvent.preventDefault();
      const {
        features
      } = event;
      if (features && features.length > 0) {
        const {
          id: bikeStationId,
          geometry
        } = features[0];
        if (typeof bikeStationId === 'number') {
          select(bikeStationsRef.current.find(_ref2 => {
            let {
              id
            } = _ref2;
            return id === bikeStationId;
          }) || null);
        }
        if (geometry.type === 'Point') {
          const {
            coordinates: [lng, lat]
          } = geometry;
          map.flyTo({
            center: {
              lat,
              lng
            },
            zoom: asMarkerMinZoom
          });
        }
      }
    });
    map.on('mouseleave', layerId, () => clearTooltip());
    initialized.current = true;
  }
  function openTooltip(id, location, title) {
    let _offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    clearTooltip();
    if (!map || !title || selectedIdRef.current === id) return;
    const {
      anchor,
      offset
    } = (0, _utils.getAnchorAndOffset)(map, location, _offset);
    tooltip.current = new _maplibreGl.Popup({
      anchor,
      offset,
      className: 'map-tooltip',
      closeButton: false
    }).setHTML(title).setLngLat(location).addTo(map);
  }
  function addMarker(bikeStation) {
    if (!map) return;
    const {
      id,
      location: {
        point: {
          coordinates: [lng, lat]
        }
      },
      label,
      availableBikesPercentage,
      status
    } = bikeStation;
    const marker = (0, _utils.createImageMarker)({
      id: `bike-station-marker-${id}`,
      radius: 14,
      borderColor: _colors.grey[500],
      borderWidth: 1,
      backgroundColor: '#fff',
      backgroundImage: (status === 'closed' ? _models.bikeStationIcons.closed : _models.bikeStationIcons[availableBikesPercentage]) || '',
      backgroundSize: 28,
      zIndex: selectedIdRef.current === id ? '2' : '1'
    }, {
      onClick: () => {
        clearTooltip();
        if (selectedIdRef.current !== id) {
          selectedIdRef.current = id;
          closePrevPopup();
          selectBikeStation(bikeStation);
          openPopup(bikeStation);
        }
      },
      onMouseEnter: () => openTooltip(id, {
        lat,
        lng
      }, label, 15),
      onMouseLeave: () => clearTooltip()
    }).setLngLat({
      lat,
      lng
    }).setPopup(new _maplibreGl.Popup({
      maxWidth: '400px',
      closeButton: false,
      closeOnClick: true,
      className: 'map-custom-popup',
      offset: 12
    }).setHTML(`<div id="bike-station-${id}-popup"></div>`).on('close', () => {
      if (selectedIdRef.current === id && markers.current[id]) {
        unselect();
      }
    })).addTo(map);
    markers.current[id] = {
      id,
      marker
    };
  }
  function openPopup(bikeStation) {
    closePrevPopup();
    if (smallDevice) return;
    const {
      id,
      location: {
        point: {
          coordinates: [lng, lat]
        }
      }
    } = bikeStation;
    const selectedMarker = selectedIdRef.current && markers.current[selectedIdRef.current];
    if (!selectedMarker) {
      unselect();
      return;
    }
    if (selectedMarker.marker.getPopup().isOpen()) return;
    selectedMarker.marker.togglePopup();
    const ele = document.getElementById(`bike-station-${id}-popup`);
    if (ele) {
      const container = (0, _client.createRoot)(ele);
      container.render( /*#__PURE__*/_react.default.createElement(_bikeStationPopup.default, {
        bikeStation: bikeStation,
        enqueueSnackbar: snackbar?.enqueueSnackbar,
        onClose: () => {
          if (selectedMarker.marker.getPopup().isOpen()) {
            selectedMarker.marker.togglePopup();
            if (container) container.unmount();
          }
        },
        onSearchUpdated: onSearchUpdated,
        onUpdated: _ref3 => {
          let {
            id,
            status,
            availableBikesPercentage
          } = _ref3;
          const ele = document.getElementById(`bike-station-marker-${id}`);
          if (ele) {
            ele.style.backgroundImage = `url(${status === 'closed' ? _models.bikeStationIcons.closed : _models.bikeStationIcons[availableBikesPercentage]})`;
          }
        },
        search: search,
        theme: theme
      }));
    }
    centerPopup({
      lat,
      lng
    }, selectedMarker.marker.getPopup(), {
      height: 400
    });
  }
  function closePrevPopup() {
    Object.values(markers.current).forEach(_ref4 => {
      let {
        id,
        marker
      } = _ref4;
      if (id !== selectedIdRef.current && marker.getPopup().isOpen()) marker.togglePopup();
    });
  }
  function select(bikeStation) {
    selectedIdRef.current = bikeStation?.id || null;
    selectBikeStation(bikeStation);
    if (!bikeStation || !map) return;
    const {
      location: {
        point: {
          coordinates: [lng, lat]
        }
      }
    } = bikeStation;
    map.flyTo({
      center: {
        lat,
        lng
      },
      zoom: asMarkerMinZoom
    });
  }
  function unselect() {
    selectedIdRef.current = null;
    selectBikeStation(null);
    closePrevPopup();
  }
  function update(bikeStations) {
    let {
      forceAsMarkers
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    bikeStationsRef.current = bikeStations;
    if (!map) return;
    const zoom = map.getZoom();
    if (zoom >= asMarkerMinZoom || forceAsMarkers) {
      clearGeoJSONSource();
      const bikeStationsIds = bikeStations.reduce((res, _ref5) => {
        let {
          id
        } = _ref5;
        res[id] = true;
        return res;
      }, {});

      // remove markers that are no longer visible
      Object.values(markers.current).filter(_ref6 => {
        let {
          id
        } = _ref6;
        return !bikeStationsIds[id];
      }).forEach(_ref7 => {
        let {
          id,
          marker
        } = _ref7;
        marker.remove();
        delete markers.current[id];
      });

      // unselect bike station if no longer visible
      if (selectedIdRef.current && !markers.current[selectedIdRef.current]) {
        unselect();
      }

      // add markers that were not visible
      bikeStations.filter(_ref8 => {
        let {
          id
        } = _ref8;
        return !markers.current[id];
      }).forEach(bikeStation => addMarker(bikeStation));

      // close previous selected bike station popup
      closePrevPopup();

      // open selected bike station popup
      const selectedBikeStation = selectedIdRef.current && bikeStations.find(_ref9 => {
        let {
          id
        } = _ref9;
        return selectedIdRef.current === id;
      });
      if (selectedBikeStation) openPopup(selectedBikeStation);
    } else {
      clearMarkers();
      unselect();
      updateGeoJSONSource({
        type: 'FeatureCollection',
        features: bikeStations.map(_ref10 => {
          let {
            id,
            label,
            location: {
              point
            },
            color
          } = _ref10;
          return {
            id,
            type: 'Feature',
            geometry: point,
            properties: {
              title: label,
              color
            }
          };
        })
      });
    }
  }
  function clearTooltip() {
    if (map) map.getCanvas().style.cursor = '';
    tooltip.current?.remove();
  }
  function clearMarkers() {
    let keepSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    Object.values(markers.current).forEach(_ref11 => {
      let {
        id,
        marker
      } = _ref11;
      if (!keepSelected || id !== selectedIdRef.current) marker.remove();
    });
    const marker = selectedIdRef.current && markers.current[selectedIdRef.current];
    if (keepSelected && selectedIdRef.current && marker) markers.current = {
      [selectedIdRef.current]: marker
    };else markers.current = {};
  }
  function clear() {
    let keepSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    bikeStationsRef.current = bikeStationsRef.current.filter(_ref12 => {
      let {
        id
      } = _ref12;
      return keepSelected && id === selectedIdRef.current;
    });
    clearMarkers(keepSelected);
    clearGeoJSONSource();
    if (!keepSelected) unselect();
    clearTooltip();
  }
  return {
    initialized: initialized.current,
    selectedBikeStation,
    init,
    update,
    unselect,
    clear
  };
}